import Breadcrumb from "../../shared/breadcrumb";
import RandomHeadImage from "../../shared/random-head-image";
import { headImages } from './_headImages';
import { industryDeployments } from "./IndustryDeployments";
import './style.scss';
import SuccessStoryModal from "./SuccessStoryModal";

var SuccessStoryItem = ({ story }) => {
  return (
    <div className="success-story-card card h-100"
      data-aos="fade-up"
      data-bs-toggle="modal"
      data-bs-target="#successStoryModal"
      data-title={story.title}
      data-title-img={story.logoUrl}
      data-description={story.description}>
      <div className="card-body">
        <div className="row">
          <div className="col">
            <h5 className="card-title">{story.title}</h5>
          </div>
        </div>
        <div className="row">
          {story.logoUrl && <div className="col-auto d-flex align-items-center">
            <img src={story.logoUrl} className="img-fluid" alt="story logo" width="100" />
          </div>}
          <div className="col">
            <p className="card-text">
              <span>
                {truncate(story.description, 70)}
              </span>
              <a href='/' data-bs-target="#exampleModal" onClick={(e) => e.preventDefault()}> &gt;&gt;</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const CustomerSayPage = (pageSettings) => {
  return (
    <>
      <RandomHeadImage items={headImages?.items} />
      <div className="container">
        <div className="my-5">
          <Breadcrumb breadcrumbPath={[{ name: "Home", path: '/' }, { name: "Testimonials" }]} />
        </div>
        <div className="row mt-5 mb-4">
          <div className="col">
            <span className="section-title">Example</span>
            <span className="section-title section-title-highlight d-none d-lg-inline-block">Industry deployments</span>
          </div>
        </div>
        <div className="row">
          {
            industryDeployments.items.map((item, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4 mb-4">
                <SuccessStoryItem story={item} />
              </div>
            ))
          }
        </div>
      </div>
      <SuccessStoryModal />
    </>
  );
};

function truncate(str, n) {
  var cut = str.indexOf(' ', n);
  if (cut === -1)
    return str;
  return str.substring(0, cut);
}

export default CustomerSayPage;